import { render, staticRenderFns } from "./dictItemAddOrEdit.vue?vue&type=template&id=1c4002c4&scoped=true"
import script from "./dictItemAddOrEdit.vue?vue&type=script&lang=js"
export * from "./dictItemAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./dictItemAddOrEdit.vue?vue&type=style&index=0&id=1c4002c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4002c4",
  null
  
)

export default component.exports